import ConfigurationItemRow from "features/configuration/GeneralConfiguration/ConfigurationItem/ConfigurationItemRow";
import {
  getFieldType,
  getIsEditable,
} from "features/configuration/GeneralConfiguration/utils";
import {
  DCA_STRATEGY_FIELD_TYPE_STRING,
  STRATEGY_FIELD_TYPE_STRING,
} from "features/configuration/common/constants";
import { toFixed } from "@shared/utils/numbers";
import { getCustomStrategyPreview } from "features/bots/common/utils";
import useMedia from "utils/hooks/useMedia";
import { MOBILE_SEARCH } from "common/constants";

const ListStrategyItem = ({
  item,
  itemValue,
  itemName,
  itemSelected,
  handleSelectStrategy,
  handleDeleteItem,
  setEditOrCreateStrategyItem,
  setItemToEdit,
  hideEditAndRemove,
}) => {
  if (item.deleted) {
    return <></>;
  }

  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);

  const getDCAStrategyPreview = () => {
    const { number_of_orders, amount_scale, price_difference, price_scale } =
      itemValue;
    return (
      <div>
        <div>Number of Orders: {number_of_orders}</div>
        <div>Amount Scale: {amount_scale}</div>
        <div>Price Difference: {toFixed(price_difference * 100, 2)}%</div>
        <div>Price Scale: {price_scale}</div>
      </div>
    );
  };

  const getStrategyPreview = () => {
    const itemType = getFieldType(item);
    if (itemType === STRATEGY_FIELD_TYPE_STRING)
      return getCustomStrategyPreview(itemValue.targets, isMobile);
    else if (itemType === DCA_STRATEGY_FIELD_TYPE_STRING)
      return getDCAStrategyPreview();
  };

  const editable = getIsEditable(item);

  return (
    <ConfigurationItemRow
      nameComponent={itemName}
      extraInfoComponent={editable ? getStrategyPreview() : undefined}
      onClickRow={handleSelectStrategy}
      deleteHandler={editable ? () => handleDeleteItem(item) : null}
      editHandler={editable ? () => setEditOrCreateStrategyItem(item) : null}
      selected={itemSelected}
      extraInfoComponentFlex="300px"
      isColoredIcons={true}
      showRadioButton={true}
      setItemToEdit={editable ? () => setItemToEdit(item) : null}
      hideEditAndRemove={hideEditAndRemove}
      style={{ alignItems: "flex-start" }}
    />
  );
};

export default ListStrategyItem;
